import { isSayAsLexeme, LexemeEntry } from '@visikon/core-models';
import * as Styles from './phoneticsmodal.styles';

export const LexemeContents = ({ lexeme }: { lexeme: LexemeEntry }) => {
  const { grapheme, stem, description } = lexeme;
  // Say-as aliases are plain text, so only phonemes get the IPA /slash/ notation
  const content = isSayAsLexeme(lexeme) ? `"${lexeme.sayAs}"` : `/${lexeme.phoneme}/`;

  return (
    <Styles.LexemeRow title={description || undefined}>
      <Styles.LexemeGrapheme>{grapheme}</Styles.LexemeGrapheme>
      <Styles.LexemeContent>{content}</Styles.LexemeContent>
      {stem && <Styles.LexemeStem>stem: {stem}</Styles.LexemeStem>}
    </Styles.LexemeRow>
  );
};
